import { parseContactData } from 'api/parsers/parseContactData';
import { fetch } from 'api/typedFetch';

export const getData = async (id: string) => {
  const response = await fetch('GET_CONTACT_US', { params: new URLSearchParams({ app_id: id }) });
  const data = await response.json();

  if (data.result === 'success') {
    return data.response.map(parseContactData);
  }

  throw new Error('Failed to fetch contact data');
};
